export default "__VITE_ASSET__CDk3b1lU__"